import { action } from 'typesafe-actions'

import { Id, RequestApprovalStatus } from 'src/types'

import { ApprovalsActionTypes, ResponseDataApprovals } from './types'

interface Options {
  filterStatus?: string[]
  page?: number
  reload?: boolean
  request_ids?: string[]
}

export const getApprovals = (
  options: Options = {
    filterStatus: [],
    page: 1,
    reload: false,
    request_ids: []
  }
) => action(ApprovalsActionTypes.GET_APPROVALS, { options })

export const getApprovalsSuccess = ({
  requests: list,
  total_results
}: ResponseDataApprovals) =>
  action(ApprovalsActionTypes.GET_APPROVALS_SUCCESS, {
    list,
    total_results
  })

export const getApprovalsFailure = (message: string) =>
  action(ApprovalsActionTypes.GET_APPROVALS_FAILURE, { message })

export const setApprovalStatus = ({
  justification,
  request_id,
  request_approval_ids,
  status
}: {
  justification: string
  request_id: Id
  request_approval_ids: Id[]
  status: RequestApprovalStatus
}) =>
  action(ApprovalsActionTypes.SET_APPROVAL_STATUS, {
    justification,
    request_id,
    request_approval_ids,
    status
  })

export const setApprovalStatusSuccess = (message: string) =>
  action(ApprovalsActionTypes.SET_APPROVAL_STATUS_SUCCESS, { message })

export const setApprovalStatusFailure = (message: string) =>
  action(ApprovalsActionTypes.SET_APPROVAL_STATUS_FAILURE, { message })
